import React from 'react';
/* External */
import PropTypes from 'prop-types';

/* Components */
import TracksMenu from '../TracksMenu/TracksMenu';
import SubtitleTracksMenu from '../SubtitleTracksMenu/SubtitleTracksMenu';

/* Styles */
import './AudioSubtitlesMenuContent.scss';

/**
 * Component TracksMenuContainer
 * @description Component that contains a track list from the player tech
 * this component treats the information and passes it  to the TracksMenu component
 */
function AudioSubtitlesMenuContent({
  audioTracks,
  onSelectAudio,
  subtitleTracks,
  onSelectSubtitle,
  onDisableSubtitles,
  audioTitle,
  subtitlesTitle,
  getLanguageLabel,
}) {
  return (
    <div className="dtv-common-c-audio-subtitles-menu-content-v2">
      <div className="dtv-common-c-audio-subtitles-menu-content-v2__sub-menu-audio">
        <TracksMenu
          title={audioTitle}
          tracks={audioTracks}
          onSelectTrack={onSelectAudio}
          getLanguageLabel={getLanguageLabel}
        />
      </div>
      <div className="dtv-common-c-audio-subtitles-menu-content-v2__sub-menu-text">
        <SubtitleTracksMenu
          tracks={subtitleTracks}
          onSelectTrack={onSelectSubtitle}
          onDisableSubtitles={onDisableSubtitles}
          title={subtitlesTitle}
          getLanguageLabel={getLanguageLabel}
        />
      </div>
    </div>
  );
}

const trackShape = PropTypes.shape({
  name: PropTypes.string,
  isSelected: PropTypes.bool,
});

AudioSubtitlesMenuContent.propTypes = {
  audioTracks: PropTypes.arrayOf(trackShape),
  onSelectAudio: PropTypes.func,
  subtitleTracks: PropTypes.arrayOf(trackShape),
  onSelectSubtitle: PropTypes.func,
  onDisableSubtitles: PropTypes.func,
  audioTitle: PropTypes.string,
  subtitlesTitle: PropTypes.string,
  getLanguageLabel: PropTypes.func,
};

AudioSubtitlesMenuContent.defaultProps = {
  audioTracks: [],
  onSelectAudio() {},
  subtitleTracks: [],
  onSelectSubtitle() {},
  onDisableSubtitles() {},
  audioTitle: '',
  subtitlesTitle: '',
  getLanguageLabel() {},
};

export default AudioSubtitlesMenuContent;
